import { MeResponse } from "../types";
import { TabKey } from "../components/TabBar";

/** Раздел «Ещё» — список вторичных разделов мини-аппа. */
export function MorePage({
  me,
  onNavigate,
}: {
  me: MeResponse;
  onNavigate: (t: TabKey) => void;
}) {
  const items: Array<{ key: TabKey; label: string; icon: string; show: boolean }> = [
    { key: "search", label: "Поиск", icon: "🔍", show: true },
    {
      key: "rubinflow",
      label: "Поступления рублей",
      icon: "💰",
      show: me.permissions.payments_view,
    },
    { key: "analytics", label: "Аналитика", icon: "📊", show: me.permissions.analytics },
    {
      key: "test_cash_position",
      label: "(тест) кассовая позиция",
      icon: "▦",
      show: me.permissions.payments_view,
    },
    {
      key: "agents",
      label: "Агенты-комиссионеры",
      icon: "🤝",
      show: me.permissions.agents_view,
    },
    {
      key: "returns",
      label: "Возвраты",
      icon: "↩️",
      show: me.permissions.returns_view,
    },
    {
      key: "subcontractors",
      label: "Субподрядчики",
      icon: "🤝",
      show: me.permissions.subcontractors_view,
    },
    {
      key: "backfill",
      label: "Дозаполнить",
      icon: "📝",
      show: me.permissions.backfill_view,
    },
    {
      key: "key_analytics",
      label: "Аналитика (обезличенно)",
      icon: "📊",
      show: me.permissions.key_analytics,
    },
    {
      key: "client_cost",
      label: "Стоимость для клиента",
      icon: "📈",
      show: me.permissions.client_cost,
    },
    { key: "audit", label: "Аудит", icon: "🚨", show: me.permissions.audit },
    {
      key: "exports_import",
      label: "Импорт экспортных заявок",
      icon: "📥",
      show: me.roles.includes("admin") || me.roles.includes("finance_lead"),
    },
    {
      key: "closeout",
      label: "Закрытие периода",
      icon: "📅",
      show: me.roles.includes("admin"),
    },
    {
      key: "trash",
      label: "Корзина заявок",
      icon: "🗑",
      show: me.roles.includes("admin"),
    },
    { key: "settings", label: "Профиль", icon: "⚙️", show: true },
    {
      key: "health",
      label: "Состояние системы",
      icon: "🩺",
      show: me.roles.includes("admin"),
    },
  ];
  const visible = items.filter((i) => i.show);
  return (
    <div>
      <h1 className="text-xl font-semibold mb-3">☰ Ещё</h1>
      <div className="bg-tg-sectionBg rounded-xl divide-y divide-tg-secondaryBg overflow-hidden">
        {visible.map((i) => (
          <button
            key={i.key}
            onClick={() => onNavigate(i.key)}
            className="w-full px-4 py-3.5 flex items-center gap-3 text-sm"
          >
            <span className="text-lg">{i.icon}</span>
            <span className="font-medium">{i.label}</span>
            <span className="ml-auto text-tg-hint">›</span>
          </button>
        ))}
      </div>
    </div>
  );
}
